<template>
  <fb-form-properties-manager id="crud-v1-properties-iujlrp" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "CrudV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "textInput",
          properties: {
            label: "Add Record Label"
          },
          property: "addRecordLabel"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        },
        {
          type: "checkbox",
          properties: {
            label: "Exclude from Paste content"
          },
          property: "excludeFromPasteContent"
        }
      ]
    };
  }
};
</script>

<style></style>
